import { useLocation } from "@madmedical/routing";
import { useCallback } from "react";
import useGeneratePath from "./useGeneratePath";
/**
 * Only active if fully matching
 */
export default () => {
    const { pathname } = useLocation();
    const generatePath = useGeneratePath();
    return useCallback((route, params) => pathname === generatePath(route, params), [generatePath, pathname]);
};
